import React,{useEffect,useState} from "react";
import {useSelector} from "react-redux";
import useAiFeatures,{aiHref} from "./useAiFeatures";
import {API_URL} from "./environment";

// /ai-workspace/<page>: opens a Stratic AI page. With web single sign-in on (SAM API SAM_WEB_AI_HANDOFF=true),
// SAM mints a single-use 60-second hand-off token for the signed-in user and the AI page redeems it, so the
// agent is not asked for the SAM password again (the Stratic MFA step still applies on an untrusted device).
// The token travels in the URL fragment, which browsers never send to a server. Without it, the page opens
// as before and the AI pages ask the user to sign in.
const PAGES=["contracts","compliance","insights","search","assistant"];
export default function AiRoute({feature}){
  const access=useAiFeatures();
  const token=useSelector(state=>state.auth.accessToken);
  const route=PAGES.includes(feature)?feature:null;
  const allowed=access.enabled&&(feature==="assistant"||access.agent_workspace);
  const destination=route&&aiHref(route);
  const [opening,setOpening]=useState(false);
  useEffect(()=>{
    if(access.status!=="ready"||access.cached||!allowed||!destination||opening)return;
    setOpening(true);
    const plain=()=>window.location.replace(destination);
    fetch(API_URL+"/ai-web-handoff",{method:"POST",headers:{Authorization:`Bearer ${token}`},cache:"no-store"})
      .then(r=>r.ok?r.json():null)
      .then(data=>{
        if(!data||typeof data.token!=="string"||data.token.length<100||data.token.length>1900)return plain();
        const url=new URL(destination);
        url.hash="/sam-handoff?"+new URLSearchParams({t:data.token,next:route}).toString();
        window.location.replace(url.href);
      })
      .catch(plain);
  },[access.status,access.cached,allowed,destination,opening,route,token]);
  if(access.status==="loading"||(access.cached&&access.status==="ready"&&!opening))return <main aria-busy="true"><p role="status">Checking your AI access…</p></main>;
  if(access.status==="error")return <main><h1>Workspace unavailable</h1><p role="alert">We could not check access. Please retry.</p><button onClick={()=>window.location.reload()}>Retry</button></main>;
  if(!allowed)return <main><h1>No access</h1><p>Ask your Stratic administrator to review your AI role.</p><a href="/">Return to SAM</a></main>;
  if(!destination)return <main><h1>Workspace not connected</h1><p>Your AI workspace address has not been configured.</p><a href="/">Return to SAM</a></main>;
  return <main aria-busy="true"><p role="status">Opening Stratic…</p></main>;
}
